// Shared camera manager to ensure only one camera is active at a time
class CameraManager {
  constructor() {
    this.activeComponent = null;
    this.listeners = new Set();
  }

  // Register a component to listen for camera state changes
  register(component) {
    this.listeners.add(component);
  }

  // Unregister a component
  unregister(component) {
    this.listeners.delete(component);
    if (this.activeComponent === component) {
      this.activeComponent = null;
    }
  }

  // Request camera access for a component
  requestCamera(component, componentName) {
    // If another component is using the camera, stop it first
    if (this.activeComponent && this.activeComponent !== component) {
      // Notify the current active component to stop its camera
      this.notifyListeners(this.activeComponent, false);
    }
    
    this.activeComponent = component;
    this.activeComponentName = componentName;
    this.notifyListeners(component, true);
    return true;
  }

  // Release camera from a component
  releaseCamera(component) {
    if (this.activeComponent === component) {
      this.activeComponent = null;
      this.activeComponentName = null;
      // Don't notify listeners when releasing camera - only when requesting
    }
  }

  // Check if a component can use the camera
  canUseCamera(component) {
    return this.activeComponent === null || this.activeComponent === component;
  }

  // Get the name of the active component
  getActiveComponentName() {
    if (!this.activeComponent) return null;
    return this.getComponentName(this.activeComponent);
  }

  // Helper to get component name
  getComponentName(component) {
    if (component.$options.name) {
      return component.$options.name;
    }
    // Fallback to check component file or constructor name
    if (component.$vnode && component.$vnode.componentOptions && component.$vnode.componentOptions.tag) {
      return component.$vnode.componentOptions.tag;
    }
    return 'Unknown Component';
  }

  // Notify all listeners about camera state changes
  notifyListeners(activeComponent, isActive) {
    const componentName = this.activeComponentName || this.getComponentName(activeComponent);
    this.listeners.forEach(listener => {
      if (listener !== activeComponent && typeof listener.onCameraStateChanged === 'function') {
        listener.onCameraStateChanged(activeComponent, componentName);
      }
    });
  }
}

// Create a singleton instance
const cameraManager = new CameraManager();

export default cameraManager;